import * as React from 'react';

import { Splide, SplideSlide } from '@splidejs/react-splide';

interface Slide {
    url: string;
}

interface Props {
    type: string;
    slides?: Slide[];
}

const splideStyles: React.CSSProperties = {
    height: '6rem',
    visibility: 'visible',
}

const certificationsMargin: React.CSSProperties = {
    marginTop: '2rem',
}

export const CertificationsComponent = (props: Props) => {
    const hasSlides = props.slides && props.slides.length > 0;
    return hasSlides && (
        <>
            <div className="certs" style={certificationsMargin}>
                <div className="o-carousel c-product-carousel-certs js-certs-product-carousel">
                    <div className="js-carousel-slides">
                        <Splide
                        style={splideStyles}
                            options={{
                                perPage: 4,
                                height: '6rem',
                                rewind: true,
                                gap: '1rem',
                            }}>
                            {
                                props?.slides?.map((slide, slideIndex) => {
                                    return (
                                        <SplideSlide key={slideIndex}>
                                            <div className="o-carousel__slides" >
                                                <div className="slide-element">
                                                    <img className="o-fit" src={slide.url} width="80" height="80" alt="" />
                                                </div>
                                            </div>
                                        </SplideSlide>
                                    )
                                })
                            }
                        </Splide>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CertificationsComponent;
